import React, { useState, useEffect } from 'react';
import { Button, Col, Row, InputGroup, Form } from 'react-bootstrap';


const BotaoFinalizar = ({ itens, desconto, total, enabled, botao }) => {
  const totalComDesconto = parseFloat(total || 0) - parseFloat(desconto || 0);
  const totalComDescontoFormatado = totalComDesconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const totalOriginal = parseFloat(total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const quantidade = itens?.reduce((acc, x) => acc + x.quantidade, 0);
  
  return (
    <div className="bs-floating shadow navbar-light">
      <div className="container py-2">
        <div className="row align-items-center">
          <div className="col">
            <div className="d-flex w-100 justify-content-between">
              Total de {quantidade} ite{quantidade > 1 ? 'ns' : 'm'}
            </div>
          </div>
          <div className="col-auto">
            <div className="fs-4">
              {parseFloat(desconto || 0) > 0 && (
                <s className="text-muted fs-6 pb-3">{totalOriginal}</s>
              )}
              {totalComDescontoFormatado}
            </div>
          </div>
        </div>
        {botao && (
          <Button variant="secondary" onClick={botao.onClick} disabled={!enabled} className="w-100 btn-lg">
            {botao.text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default BotaoFinalizar;